import React, {memo} from "react";
import cls from './empty-dot.module.css';
import {classNames} from "../../../../../../lib/classNames/classNames";

interface EmptyDotProps {
    className?: string
}

const EmptyDot: React.FC<EmptyDotProps> = memo(({className}: EmptyDotProps) => {
    return (
        <span className={classNames(cls.emptyDot, {}, [className])}/>
    )
})

export default EmptyDot
